<script>
  export let isOpen;   // injected by svelte-modals
  export let onClose;  // sometimes injected too

  import { authService } from "../../services/AuthService";

  let email = "";
  let sending = false;
  let successMsg = "";
  let errorMsg = "";

  async function sendLink() {
    successMsg = "";
    errorMsg = "";
    sending = true;
    try {
      await authService.loginWithMagicLink(email);
      successMsg = "Check your inbox for the sign-in link.";
    } catch (e) {
      console.error(e);
      errorMsg = e?.message ?? "Failed to send magic link general.";
    } finally {
      sending = false;
    }
  }
</script>

<div class="modal-overlay" on:click={() => onClose?.()}>
</div>

<div class="modal-card" on:click|stopPropagation tabindex="0">
  <h3>Sign in with Magic Link</h3>
  <input
    type="email"
    bind:value={email}
    placeholder="you@example.com"
    required
    autocomplete="email"
    autofocus
  />
  <div class="actions">
    <button type="button" on:click={() => onClose?.()} disabled={sending}>Cancel</button>
    <button type="button" on:click={sendLink} disabled={sending || !email}>
      {sending ? "Sending..." : "Send link"}
    </button>
  </div>
  {#if successMsg}<p class="ok">{successMsg}</p>{/if}
  {#if errorMsg}<p class="err">{errorMsg}</p>{/if}
</div>

<style>
  .modal-overlay{
    position: fixed; inset: 0;
    background: rgba(0,0,0,.5);
    z-index: 10000;
  }
  .modal-card{
    position: fixed; left: 50%; top: 50%;
    transform: translate(-50%,-50%);
    background: #fff; width: min(420px, 92vw);
    border-radius: 12px; padding: 20px;
    box-shadow: 0 10px 30px rgba(0,0,0,.15);
    z-index: 10001;
    pointer-events: auto; /* clickable even if parent had none */
  }
  input, button{ padding: .6rem .8rem; font-size: 1rem; }
  .actions{ display:flex; gap:.5rem; justify-content:flex-end; margin-top:.75rem; }
  .ok{ color:#0a7f2e; margin-top:.5rem; }
  .err{ color:#b00020; margin-top:.5rem; }
</style>
